const awsRumCustomEvents = {
    DEFAULT: 'DEFAULT',
    ONBOARDING: 'ONBOARDING',
    SET_UP: 'SET_UP',
    ADDING_NEW_WIFI: 'ADDING_NEW_WIFI',
    SETTINGS: 'SETTINGS',
    FIRMWARE_UPDATE: 'FIRMWARE_UPDATE',
    SILENT_FIRMWARE_UPDATE_ENABLED: 'SILENT_FIRMWARE_UPDATE_ENABLED',
    SILENT_FIRMWARE_UPDATE_DISABLED: 'SILENT_FIRMWARE_UPDATE_DISABLED',
    SYNCHRONIZE: 'SYNCHRONIZE',
    NOTIFICATIONS: 'NOTIFICATIONS',
    USER_CONSENTS: 'USER_CONSENTS',
    CONVERSION_ONBOARDING: 'CONVERSION_ONBOARDING',
    CONVERSION_SUPPORT_SURVEY: 'CONVERSION_SUPPORT_SURVEY',
    UI_FEEDBACK_SURVEY: 'UI_FEEDBACK_SURVEY',
    VISIT_FEEDBACK_SURVEY: 'VISIT_FEEDBACK_SURVEY',
    UWM_EVENT: 'UWM_EVENT',
};

export default awsRumCustomEvents;
